import React from "react";
import ReactDOM from "react-dom/client";  // Import the new createRoot API
import { Auth0Provider } from "@auth0/auth0-react";
import App from "./App";
import { registerStreamWorker } from "./utils/streamWorkerClient";

// Register stream service worker for background stream buffering (mobile)
if ('serviceWorker' in navigator) {
  registerStreamWorker().catch(err =>
    console.warn('Stream service worker registration failed:', err)
  );
}

const domain = "dev-zwkxfaoghfmkjbnv.us.auth0.com";
const clientId = "ZifV3s2aOAI4kxOm97OMcD2A0aSrcea5";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Auth0Provider
    domain={domain}
    clientId={clientId}
    authorizationParams={{
      redirect_uri: window.location.origin,
    }}
  >
    <App />
  </Auth0Provider>
);
